import React from 'react';
import { hours, shopInfo } from '../mock';
import { Instagram, Phone } from 'lucide-react';

const BarberPole = ({ className = '' }) => (
  <svg viewBox="0 0 60 180" className={className} aria-hidden="true">
    <ellipse cx="30" cy="14" rx="20" ry="8" fill="#c9a961" />
    <ellipse cx="30" cy="10" rx="20" ry="8" fill="#0a0a0a" stroke="#c9a961" strokeWidth="1.5" />
    <rect x="12" y="16" width="36" height="140" rx="3" fill="#0a0a0a" stroke="#c9a961" strokeWidth="1.5" />
    <g clipPath="url(#pole-clip-2)">
      <rect x="12" y="16" width="36" height="140" fill="#0a0a0a" />
      {[0, 20, 40, 60, 80, 100, 120, 140].map((y) => (
        <path key={y} d={`M12,${16 + y} L48,${16 + y - 14}`} stroke="#c9a961" strokeWidth="7" />
      ))}
    </g>
    <clipPath id="pole-clip-2">
      <rect x="12" y="16" width="36" height="140" rx="3" />
    </clipPath>
    <ellipse cx="30" cy="164" rx="20" ry="8" fill="#c9a961" />
    <ellipse cx="30" cy="160" rx="20" ry="8" fill="#0a0a0a" stroke="#c9a961" strokeWidth="1.5" />
  </svg>
);

const getToday = () => {
  const days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
  return days[new Date().getDay()];
};

const HoursSection = () => {
  const today = getToday();

  return (
    <section id="hours" className="relative bg-[#0f0d0a] py-28 md:py-36 border-y border-[#c9a961]/10">
      <div className="max-w-4xl mx-auto px-6">
        <div className="reveal relative bg-[#0a0a0a] border-2 border-[#c9a961]/70 p-8 md:p-14">
          {/* Title */}
          <div className="text-center mb-4">
            <div className="font-bebas text-[#c9a961] text-5xl md:text-6xl tracking-[0.05em]">
              JR BARBER
            </div>
          </div>

          <div className="relative flex items-center justify-center gap-5 mb-10 md:mb-14 max-w-2xl mx-auto">
            <BarberPole className="w-12 md:w-14 h-auto shrink-0" />
            <div className="flex-1 relative">
              <div className="border-t border-[#c9a961]/70" />
              <div className="border-t border-[#c9a961]/70 mt-1.5" />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="bg-[#0a0a0a] px-6 font-bebas text-[#c9a961] text-2xl md:text-3xl tracking-[0.4em]">
                  HORAIRES
                </span>
              </div>
            </div>
            <BarberPole className="w-12 md:w-14 h-auto shrink-0" />
          </div>

          {/* Days list */}
          <div className="space-y-4 md:space-y-5 max-w-xl mx-auto">
            {hours.map((h) => {
              const isToday = h.day === today;
              const closed = h.hours === 'Fermé';
              return (
                <div
                  key={h.day}
                  className={`grid grid-cols-[1fr_auto] items-center gap-4 md:gap-8 py-1 ${
                    isToday ? 'text-[#c9a961]' : 'text-[#f5efe4]'
                  }`}
                >
                  <div className="flex items-center gap-3">
                    {isToday && (
                      <span className="w-2 h-2 rounded-full bg-[#c9a961] animate-pulse shrink-0" />
                    )}
                    <span className="font-bebas text-3xl md:text-[38px] tracking-wider">
                      {h.day.toUpperCase()}
                    </span>
                  </div>
                  <span
                    className={`font-bebas text-3xl md:text-[38px] tracking-wider ${
                      closed ? 'text-[#a8a29e]' : ''
                    }`}
                  >
                    {closed ? 'FERMÉ' : h.hours.replaceAll(':00', 'H').replace(' – ', ' - ')}
                  </span>
                </div>
              );
            })}
          </div>

          {/* Note */}
          <div className="mt-12 pt-8 border-t border-[#c9a961]/20 text-center space-y-1.5">
            <p className="font-bebas text-[#f5efe4] text-lg md:text-xl tracking-widest">
              SUR RENDEZ-VOUS VIA PLANITY DU LUNDI AU JEUDI
            </p>
            <p className="font-bebas text-[#f5efe4] text-lg md:text-xl tracking-widest">
              UNIQUEMENT SANS RENDEZ-VOUS VENDREDI ET SAMEDI
            </p>
          </div>

          {/* Contact footer */}
          <div className="mt-10 flex flex-col md:flex-row items-center justify-center gap-6 md:gap-10 text-[#c9a961]">
            <a
              href={shopInfo.instagramUrl}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 hover:text-[#f5efe4] transition-colors"
            >
              <Instagram className="w-5 h-5" />
              <span className="font-medium tracking-wide">@{shopInfo.instagram}</span>
            </a>
            <a
              href={`tel:${shopInfo.phone.replace(/\s/g, '')}`}
              className="flex items-center gap-2 hover:text-[#f5efe4] transition-colors"
            >
              <Phone className="w-5 h-5" />
              <span className="font-medium tracking-wide">{shopInfo.phone}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HoursSection;
